module.exports = __webpack_public_path__ + "img/i_check.c8d89814.svg";